
declare const $;
export function clickOutSide_directive($rootScope) {
    "ngInject";

    var directive = {
        link: link,
        restrict: 'A',
        scope: {
            clickOutSide: "="
        }

    };
    return directive;

    function link(scope, element, attrs) {
        $(document).on('click', (event) => {
            var clickedElement = event.target;
            var elementClasses = clickedElement.classList;
            var clickedOnSearchDrawer = elementClasses.contains('searchArea')
            if (!clickedOnSearchDrawer) {
                $(element).hide()
            }
        })
        $("#SearchBox").on('focus', (event) => {
            if (event.currentTarget.value.length > 2) {
                $(element).show()
            }
        })
        scope.$watch('clickOutSide', () => {
            if (!scope.clickOutSide) {
                $(element).hide()
            }
            else {
                $(element).show()
            }
        })
    }
}


function ControllerController() {

}



// WEBPACK FOOTER //
// ./src/directives/clickOutSide/clickOutSide.ts